import { useState } from "react";
import { useDebounce } from "../hooks/use-debounce";

export interface PaginationData {
  currentPage: number;
  totalPages: number;
  total: number;
  perPage: number;
}

export const usePaginatedSearch = (initialPerPage = 10) => {
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [paginationData, setPaginationData] = useState<PaginationData>({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    perPage: initialPerPage
  });

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
    setPaginationData(prev => ({ ...prev, currentPage: 1 }));
  };

  const handlePaginate = (page: number) => {
    setPaginationData(prev => ({ ...prev, currentPage: page }));
  };

  return {
    searchTerm,
    debouncedSearchTerm,
    paginationData,
    setPaginationData,
    handleSearchChange,
    handlePaginate
  };
};
